import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { Loader2 } from "lucide-react";
import { useCreateNoteList } from "@/mutations/noteLists";

const searchParamsSchema = z.object({
  parentId: z.string().optional(),
});

export const Route = createFileRoute("/lists/new")({
  validateSearch: searchParamsSchema,
  component: NewListRedirect,
});

function NewListRedirect() {
  const { user } = Route.useRouteContext();
  const { parentId } = Route.useSearch();
  const navigate = useNavigate();
  const createMutation = useCreateNoteList();

  useEffect(() => {
    if (!user) {
      navigate({ to: "/" });
      return;
    }

    if (createMutation.isPending || createMutation.isSuccess) {
      return;
    }

    createMutation.mutate(
      {
        name: "Untitled",
        kind: "LIST",
        schema: { properties: {} },
        parentId: parentId || undefined,
      },
      {
        onSuccess: (newList) => {
          navigate({
            to: "/lists/$listId",
            params: { listId: newList.id },
          });
        },
        onError: () => {
          navigate({ to: "/lists" });
        },
      },
    );
  }, [user, parentId, navigate, createMutation]);

  return (
    <div className="flex items-center justify-center h-full">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}
